// =============================================================================
// Strażnik tras samoobsługowej sprzedaży (Marketplace, Billing) dla fazy 1.
//
// Menu chowa pozycje, ale trasy da się otworzyć z adresu — stąd strażnik.
// To WIDOCZNOŚĆ, nie bramka dostępu: uruchomienie organu i tak rozstrzyga
// baza (minimalny plan modułu, migracja 754). Patrz `lib/fazaSprzedazy.ts`.
// =============================================================================

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { ukryjSprzedazSamoobslugowa } from '../lib/fazaSprzedazy';
import { useAuth } from '../providers/AuthProvider';

export function StrazSprzedazySamoobslugowej({ children }: { children: ReactNode }) {
  const { user, currentOrganization } = useAuth();
  if (ukryjSprzedazSamoobslugowa(currentOrganization?.organization, user)) {
    return <Navigate to="/admin" replace />;
  }
  return <>{children}</>;
}
